/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2025-02-10 15:21:56                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-03-03 14:58:36                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Components
  * WorkorderListItem: Display workorder list item
*/

/* Imports */
/***/

/* Components */
import toast from "react-hot-toast";
import { showApiErrorToast } from "../../../../../../services/api/error";
/***/

import EditCreateDrawer from "../../../../../../components/edit-create-drawer/EditCreateDrawer";
import { api } from "../../../../../../services/api/api";
import ActivitySectorForm from "../../../../../../components/data/activity-sector/ActitivitySectorForm";


/**
* WorkorderListItem: Display workorder list item
* @param workorder - Workorder data
* @param onClick - On click event
* @param isLast - Is last item
*/
export default function ActivitySectorAdminActions({
  activity,
  onChange
}: {
  activity: EasyTech.ActivitySector,
  onChange: () => void
}) {
  /**
  * updateTechnician: update technician information
  * @param tech - technician data to update
  */
  const updateOrigin = (type: EasyTech.ActivitySector): Promise<void> => {
    if (type.translations) {
      type.translations = type.translations.filter((el: EasyTech.Translation) => {
        const cond = !el.label;
        return !cond;
      });
    }
    return new Promise((resolve, reject) => {
      if (type && type.label && type.id) {
        api.put("admin/customer_activity/" + type.id, type).then((ret) => {
          onChange();
          toast.success("Customer activity sector updated");
          return resolve();
        }).catch((error: any) => {
          console.error(error);
          showApiErrorToast(error, { fallbackMessage: "Erreur lors de la mise à jour du secteur d'activité" });
          return reject();
        });
      } else {
        toast.error("Form is invalid");
        return reject();
      }
    });
  };
  /***/

  return (
    <div className="admin-wo-actions">
      <EditCreateDrawer data={(activity as EasyTech.ActivitySector)}
        entityName="Activity Sector"
        FormComponent={ActivitySectorForm}
        isNotCreatable={true}
        onSubmit={updateOrigin} />
    </div>
  );
}
/***/
